import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import editCommand from "./command";
import { COMMAND_NAME_EDIT } from "../constant";

export default class ImageEditEditing extends Plugin {
  init() {
    const editor = this.editor;
    const data = editor.data;
    const editing = editor.editing;

    // 监听 src 和 title 属性的变更，需要从 editing 和 data 中获取 downcastDispatcher
    // editing.downcastDispatcher.on(
    //   "attribute:src:image",
    //   modelToViewConverter("src")
    // );
    // data.downcastDispatcher.on(
    //   "attribute:src:image",
    //   modelToViewConverter("src")
    // );
    // editing.downcastDispatcher.on(
    //   "attribute:title:image",
    //   modelToViewConverter("title")
    // );
    // data.downcastDispatcher.on(
    //   "attribute:title:image",
    //   modelToViewConverter("title")
    // );

    const command = new editCommand(editor);
    editor.commands.add(COMMAND_NAME_EDIT, command);
  }
}

function modelToViewConverter(attr) {
  return (evt, data, conversionApi) => {

    // CK5 会将属性的更改状态保存为 consumable，用于校验该变化是否已经完成
    if (!conversionApi.consumable.consume(data.item, evt.name)) {
      return;
    }

    const viewElement = conversionApi.mapper.toViewElement(data.item);
    const viewWriter = conversionApi.writer;
    const imageInner = viewElement.getChild(0);

    // 修改视图中对应的属性
    viewWriter.setAttribute(
      attr,
      data.attributeNewValue,
      imageInner
    );

    // 阻止事件冒泡
    evt.stop();
  };
}